import React from 'react';
import { Link } from 'react-router-dom';
import './QuickBundles.css';

const QuickBundles = () => {
  const bundles = [
    {
      id: 1,
      name: "Pro Angler Bundle",
      description: "Complete setup with 9\" screen, Livescope, and premium accessories",
      price: 2499.99,
      image: "/images/pro-bundle.jpg",
      features: [
        "9\" GPSMAP Screen",
        "LiveScope Plus System",
        "30Ah Lithium Battery",
        "Premium Shuttle & Pole"
      ]
    },
    {
      id: 2,
      name: "Weekend Warrior",
      description: "Perfect starter kit with 7\" screen and essential gear",
      price: 1499.99,
      image: "/images/weekend-bundle.jpg",
      features: [
        "7\" ECHOMAP Screen",
        "Traditional Transducer",
        "20Ah Lithium Battery",
        "Standard Shuttle & Pole"
      ]
    },
    {
      id: 3,
      name: "Ice Fishing Special",
      description: "Complete ice fishing setup with 5\" screen and ice-specific gear",
      price: 999.99,
      image: "/images/ice-bundle.jpg",
      features: [
        "5\" STRIKER Screen",
        "Ice Fishing Transducer",
        "12Ah Lithium Battery",
        "Ice Fishing Kit"
      ]
    },
    {
      id: 4,
      name: "Elite Package",
      description: "Top-tier setup with 12\" screen and all premium accessories",
      price: 3499.99,
      image: "/images/elite-bundle.jpg",
      features: [
        "12\" GPSMAP Screen",
        "LiveScope Plus System",
        "50Ah Lithium Battery",
        "Premium Shuttle & Pole"
      ]
    }
  ];

  return (
    <div className="quick-bundles-page">
      <div className="page-header">
        <h1>Quick Start Bundles</h1>
        <p className="subtitle">Popular pre-configured setups ready to go</p>
      </div>

      <div className="bundles-grid">
        {bundles.map((bundle) => (
          <div key={bundle.id} className="bundle-card">
            <div className="bundle-image">
              <img src={bundle.image} alt={bundle.name} />
            </div>
            <div className="bundle-content">
              <h2>{bundle.name}</h2>
              <p className="bundle-description">{bundle.description}</p>
              <div className="bundle-features">
                <h3>Includes:</h3>
                <ul>
                  {bundle.features.map((feature, index) => (
                    <li key={index}>{feature}</li>
                  ))}
                </ul>
              </div>
              <div className="bundle-price">${bundle.price.toLocaleString()}</div>
              <div className="bundle-actions">
                <Link to={`/bundle/${bundle.id}`} className="view-details-btn">
                  View Details
                </Link>
                <Link to="/custom-builder" className="customize-btn">
                  Customize Your Own
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="custom-builder-cta">
        <p>Want to build your own custom bundle?</p>
        <Link to="/custom-builder" className="start-building-btn">
          Start Building Your Own
        </Link>
      </div>
    </div>
  );
};

export default QuickBundles; 